import { Status } from './Status';
import { ReportIcon, AddToReportCheckIcon } from '@cdl/heartbeat-react';

interface Props {
  changed: boolean;
}

export const SavedStatus: React.FC<Props> = ({ changed }) => {
  return (
    <>
      {changed && <Status label='Draft' icon={<ReportIcon fontSize='xs' />} />}
      {!changed && (
        <Status
          label='Saved'
          icon={<AddToReportCheckIcon fontSize='xs' />}
          colorScheme='green'
        />
      )}
    </>
  );
};
